class Task {
  constructor(data) {
    this.pk = data.pk;
    this.status = data.status.status_name;
    this.name = data.task_master.name;
    this.isClosed = data.is_closed;
    this.modifiedAt = data.modified_at;
    this.description = data.task_master.description;
  }
}
export default Task;